// services/alerts.js
import axiosInstance from './axiosInstance';

const ALERTS_API_URL = '/alerts';

const alertsService = {
  async check(idempresa) {
    try {
      const response = await axiosInstance.get(`${ALERTS_API_URL}/check.php?idempresa=${idempresa}`, {
        skipGlobalLoading: true // Não mostrar loading global para alertas
      });
      return response.data !== "NOK" ? (response.data || []) : [];
    } catch (error) {
      console.error('Erro ao verificar alertas:', error);
      return [];
    }
  }
};

export default alertsService;
